export const FRONT_DATE_FORMAT = "DD.MM.YYYY";
export const BACK_DATE_FORMAT = "YYYY-MM-DD";
